import React from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import { ModalHeader, ScrollableContent, ModalContent, ModalRow, ModalRowLabel, ModalRowValue, ModalSection, ModalSectionTitle, EditButton, } from "../Styles/InputStyles";
import { FiDownload } from "react-icons/fi";

import ModalProfileHeader from "../Common/ModalProfileHeader";
import { capitalizeFirstLetter } from "../../helpers";

// Option mappings
const genderOptions = [
    { value: 1, label: 'Male' },
    { value: 2, label: 'Female' },
    { value: 3, label: 'Others' },
];

// const occupationOptions = [
//     { value: 1, label: 'Student' },
//     { value: 2, label: 'Salaried' },
// ];

const academicStandingOptions = [
    { value: 1, label: '1st Year' },
    { value: 2, label: '2nd Year' },
    { value: 3, label: '3rd Year' },
    { value: 4, label: '4th Year' },
];

const relationOptions = [
    { value: 3, label: 'Brother' },
    { value: 4, label: 'Sister' },
    { value: 1, label: 'Uncle' },
    { value: 2, label: 'Aunt' },
    { value: 5, label: 'Friend' },
];

// Helper functions to get labels from values
const getGenderLabel = (value) => {
    const option = genderOptions.find(opt => opt.value === value);
    return option ? option.label : '-';
};

// const getOccupationLabel = (value) => {
//     const option = occupationOptions.find(opt => opt.value === value);
//     return option ? option.label : '-';
// };

const getAcademicStandingLabel = (value) => {
    const option = academicStandingOptions.find(opt => opt.value === value);
    return option ? option.label : '-';
};

const getRelationLabel = (value) => {
    const option = relationOptions.find(opt => opt.value === value);
    return option ? option.label : '-';
};

const ViewDetails = ({ setIsViewDetails, selectedData, onDownloadDetails, isDownloading, onAssignProperty,
    isAssigningProperty = false,
    showAssignButton = false }) => {
    const onClose = () => setIsViewDetails(false);
    const isSettled = selectedData.settleStatus === 3;

    // Helper function to format dates
    const formatDate = (date) => {
        if (!date) return '-';
        return moment(date).format("DD, MMM YYYY");
    };
    const handleDownload = () => {
        if (onDownloadDetails && selectedData?.tenantId) {
            onDownloadDetails(selectedData.tenantId);
        }
    };

    const handleAssignProperty = () => {
        if (onAssignProperty && selectedData?.id) {
            // Pass tenant data with a parameter
            onAssignProperty({
                tenantId: selectedData.tenantId,
                tenantName: selectedData.tenantName,
                tenantMobile: selectedData.tenantMobile,
                gender: selectedData.gender,
                occupation: selectedData.occupation
            });
        }
    };

    return (
        <Container>
            {/* Header */}
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">View Details</h1>
                <button onClick={onClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            <ModalProfileHeader
                title="Tenant Details"
                name={capitalizeFirstLetter(selectedData?.tenantName)}
                subtitle={`#${selectedData?.tenantMobile}`}
                image={selectedData?.profilePicture}
                onClose={onClose}
            />

            {/* ModalContent */}
            <ModalContent>
                <ScrollableContent>
                    <Wrapper>
                        {/* Personal Information */}
                        <BtnWrapper>
                            <ModalSectionTitle>Personal Information</ModalSectionTitle>
                            {/* <EditButton
                                title="Download Detail"
                                onClick={handleDownload}
                                disabled={isDownloading}
                            >
                                {isDownloading ? 'Downloading...' : 'Download Details'}
                            </EditButton> */}

                            {/* {selectedData?.downloadLink && ( */}
                            <button
                                onClick={handleDownload}
                                disabled={isDownloading}
                                className="flex items-center gap-1 text-sm text-primary-color hover:underline disabled:opacity-50"
                            >
                                <FiDownload size={16} />
                                {isDownloading ? "Downloading..." : "Download"}
                            </button>
                            {/* )} */}
                        </BtnWrapper>
                        <ModalSection>
                            <ModalRow>
                                <FlexCol>
                                    <ModalRowLabel>Aadhar Number</ModalRowLabel>
                                    <ModalRowValue>{selectedData?.aadharNumber || '-'}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <ModalRowLabel>Gender</ModalRowLabel>
                                    <ModalRowValue>{getGenderLabel(selectedData?.gender)}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>
                                <FlexCol>
                                    <ModalRowLabel>Date of Birth</ModalRowLabel>
                                    <ModalRowValue>{formatDate(selectedData?.dob)}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <ModalRowLabel>Email</ModalRowLabel>
                                    <ModalRowValue>{selectedData?.tenantEmail || '-'}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            {selectedData?.address && (
                                <ModalRow className="grid-cols-1">
                                    <FlexCol>
                                        <ModalRowLabel>Address</ModalRowLabel>
                                        <ModalRowValue>{selectedData?.address}</ModalRowValue>
                                    </FlexCol>
                                </ModalRow>
                            )}
                        </ModalSection>

                        {/* Professional/Academic Information */}
                        <BtnWrapper>
                            <ModalSectionTitle>Professional & Academic Details</ModalSectionTitle>
                        </BtnWrapper>
                        <ModalSection>
                            <ModalRow>
                                <FlexCol>
                                    <ModalRowLabel>Occupation</ModalRowLabel>
                                    <ModalRowValue>{selectedData?.occupation}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <ModalRowLabel>Institution/Company</ModalRowLabel>
                                    <ModalRowValue>{selectedData?.institutionName || '-'}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>
                                <FlexCol>
                                    <ModalRowLabel>Student/Employee Id</ModalRowLabel>
                                    <ModalRowValue>{selectedData?.institutionId || '-'}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <ModalRowLabel>Designation/Course</ModalRowLabel>
                                    <ModalRowValue>{selectedData?.designation || '-'}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>

                            <ModalRow>
                                <FlexCol>
                                    <ModalRowLabel>Domain/Stream</ModalRowLabel>
                                    <ModalRowValue>{selectedData?.domain || '-'}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <ModalRowLabel>Tenure</ModalRowLabel>
                                    <ModalRowValue>{getAcademicStandingLabel(selectedData?.tenure)}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                            <ModalRow>
                                <FlexCol>
                                    <ModalRowLabel>Intake Date</ModalRowLabel>
                                    <ModalRowValue>{selectedData?.intakeDate}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                        </ModalSection>

                        {/* Parent and Guardian Information */}
                        <BtnWrapper>
                            <ModalSectionTitle>Parent & Guardian Details</ModalSectionTitle>
                        </BtnWrapper>
                        <ModalSection>
                            <ModalRow>
                                <FlexCol>
                                    <ModalRowLabel>Father's Name</ModalRowLabel>
                                    <ModalRowValue>{selectedData?.fatherName || '-'}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <ModalRowLabel>Father's Mobile</ModalRowLabel>
                                    <ModalRowValue>{selectedData?.fatherMobile || '-'}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                            <ModalRow>
                                <FlexCol>
                                    <ModalRowLabel>Father's Email</ModalRowLabel>
                                    <ModalRowValue>{selectedData?.fatherEmail || '-'}</ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                            {selectedData?.motherName && (
                                <ModalRow>
                                    <FlexCol>
                                        <ModalRowLabel>Mother's Name</ModalRowLabel>
                                        <ModalRowValue>{selectedData?.motherName}</ModalRowValue>
                                    </FlexCol>
                                    {selectedData?.motherMobile && (
                                        <FlexCol>
                                            <ModalRowLabel>Mother's Mobile</ModalRowLabel>
                                            <ModalRowValue>{selectedData?.motherMobile}</ModalRowValue>
                                        </FlexCol>
                                    )}
                                </ModalRow>
                            )}
                            {selectedData?.motherEmail && (
                                <ModalRow>
                                    <FlexCol>
                                        <ModalRowLabel>Mother's Email</ModalRowLabel>
                                        <ModalRowValue>{selectedData?.motherEmail}</ModalRowValue>
                                    </FlexCol>
                                </ModalRow>
                            )}
                            {selectedData?.localGuardianName && (
                                <ModalRow>
                                    <FlexCol>
                                        <ModalRowLabel>Guardian Name</ModalRowLabel>
                                        <ModalRowValue>{selectedData?.localGuardianName}</ModalRowValue>
                                    </FlexCol>
                                    {selectedData?.localGuardianRelation && (
                                        <FlexCol>
                                            <ModalRowLabel>Relation</ModalRowLabel>
                                            <ModalRowValue>{getRelationLabel(selectedData?.localGuardianRelation)}</ModalRowValue>
                                        </FlexCol>
                                    )}
                                </ModalRow>
                            )}
                            {(selectedData?.localGuardianMobile || selectedData?.localGuardianEmail) && (
                                <ModalRow>
                                    {selectedData?.localGuardianMobile && (
                                        <FlexCol>
                                            <ModalRowLabel>Guardian Mobile</ModalRowLabel>
                                            <ModalRowValue>{selectedData?.localGuardianMobile}</ModalRowValue>
                                        </FlexCol>
                                    )}
                                    {selectedData?.localGuardianEmail && (
                                        <FlexCol>
                                            <ModalRowLabel>Guardian Email</ModalRowLabel>
                                            <ModalRowValue>{selectedData?.localGuardianEmail}</ModalRowValue>
                                        </FlexCol>
                                    )}
                                </ModalRow>
                            )}
                        </ModalSection>


                        {/* Additional Information */}
                        <BtnWrapper>
                            <ModalSectionTitle>Additional Information</ModalSectionTitle>
                        </BtnWrapper>
                        <ModalSection>
                            <ModalRow>
                                <FlexCol>
                                    <ModalRowLabel>Application Number</ModalRowLabel>
                                    <ModalRowValue>{selectedData?.applicationNumber || '-'}</ModalRowValue>
                                </FlexCol>
                                {/* <FlexCol>
                                    <ModalRowLabel>Status</ModalRowLabel>
                                    <ModalRowValue>{selectedData?.status === 1 ? 'Active' : selectedData?.status === 0 ? 'Inactive' : 'Suspended'}</ModalRowValue>
                                </FlexCol> */}
                            </ModalRow>

                            <ModalRow>
                                <FlexCol>
                                    <ModalRowLabel>Move In Date</ModalRowLabel>
                                    <ModalRowValue>{formatDate(selectedData?.moveInDate)}</ModalRowValue>
                                </FlexCol>
                                <FlexCol>
                                    <ModalRowLabel>Created At</ModalRowLabel>
                                    <ModalRowValue>
                                        {selectedData?.createdAt ? moment(selectedData?.createdAt).format("DD, MMM YYYY, hh:mm A") : '-'}
                                    </ModalRowValue>
                                </FlexCol>
                            </ModalRow>
                            {selectedData?.description &&
                                <ModalRow className="grid grid-cols-1">
                                    <FlexCol>
                                        <ModalRowLabel>Remark</ModalRowLabel>
                                        <ModalRowValue>
                                            {selectedData?.description}
                                        </ModalRowValue>
                                    </FlexCol>
                                </ModalRow>}
                        </ModalSection>

                    </Wrapper>
                </ScrollableContent>
            </ModalContent>
        </Container>
    );
};

export default ViewDetails;

// ---------------- Styled Components ----------------
const Wrapper = tw.div`grid gap-2 my-0`;
const Container = tw.div`bg-white w-full h-full min-h-[100vh] flex flex-col`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
//const FlexCol = tw.div`flex flex-col gap-0.5`;
const FlexCol = tw.div`flex flex-col gap-0.5 min-w-0`;